import dynamic from 'next/dynamic';
import Box from '@mui/material/Box';

// Disable SSR for both components to prevent hydration issues with:
// - Client-side state (pagination)
// - Animations (Fade)
// - SVG icons (ChevronLeft/Right)
const PaginatedBankPartners = dynamic(
  () =>
    import('./PaginatedBankPartners').then((mod) => ({
      default: mod.PaginatedBankPartners,
    })),
  { ssr: false },
);

const BankPartnerGallery = dynamic(
  () =>
    import('./BankPartnerGallery').then((mod) => ({
      default: mod.BankPartnerGallery,
    })),
  { ssr: false }, // This is important to prevent hydration issues
);

export const PartnerBanks = () => {
  return (
    <Box>
      {/* Mobile: show PaginatedBankPartners up to md */}
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <PaginatedBankPartners />
      </Box>

      {/* Desktop: show BankPartnerGallery for md and above */}
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <BankPartnerGallery />
      </Box>
    </Box>
  );
};
